(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/views/template.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/views/template.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.map_of_winners=_svs.map_of_winners||{};
_svs.map_of_winners.templates=_svs.map_of_winners.templates||{};
svs.map_of_winners.templates.template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"mowMapRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-map_of_winners-template'] = svs.map_of_winners.templates.template;
})(svs, Handlebars);


 })(window);